import React from 'react'
import './Footer.css'


const Footer = () => {
  return (
<footer
  className="footer"
>
  <p className="copyleft">
    Email: <a href="mailto:Larsgregersen1990@gmail.com">Larsgregersen1990@gmail.com</a>
  </p>
  <p className="copyright">
    &copy; 2024 Web App. All rights reserved.
  </p>
</footer>

  )
}

export default Footer;